<template>
  <div class="video-index">
    <ul>
      <li @click="toPlayVideo(item)" v-for="(item, index) in videoList" :key="index">
        <img :src="item.cover" alt="" />
        <div class="vname">
          {{ item.videoName }}
        </div>
        <div class="num">
          <img src="@/assets/img/newUser/video.png" alt="" />
          <span>{{ item.playNum }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    videoList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    toPlayVideo(item) {
      const {
        videoId, videoName, vid, id,
      } = item;
      this.$router.push({
        path: 'newUservideo',
        query: {
          vid,
          cid: videoId,
          vname: videoName,
          id,
          activeId: this.$route.query.activeId,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.video-index {
  width: 100%;
  padding: 32px 40px;
  ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    li {
      position: relative;
      width: 320px;
      height: 300px;
      background: #fff;
      // margin-bottom: 40px;
      img {
        width: 320px;
        height: 180px;
      }
      .vname {
        margin: 16px 0 0 0;
        padding: 0 0 0 10px;
        overflow: hidden;
        color: #333;
        font-size: 28px;
        line-height: 35px;
        @extend .ellipsis-2;
      }
      .num {
        position: absolute;
        top: 145px;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 35px;
        padding: 0 0 0 7px;
        background: url('../../../assets/img/newUser/video-bg.png') no-repeat;
        background-size: 100%;
        > img {
          width: 28px;
          height: 28px;
          margin-right: 5px;
          vertical-align: middle;
        }
        span {
          color: #fff;
          font-size: 24px;
        }
      }
    }
    li:nth-child(2n) {
      margin-left: 28px;
    }
  }
}
</style>
